
import { Component, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { AuthMixin } from '@/mixins/AuthMixin';
import { WhatsAppApi } from '@/api/WhatsAppApi';
import { WhatsAppMessageTemplate } from 'ignite360-core';

@Component({
  name: 'message-template-list-card',
  components: {},
})
export default class MessageTemplateListCard extends mixins(AuthMixin) {
  messageTemplates: WhatsAppMessageTemplate[] = [];

  sortTemplates(a: WhatsAppMessageTemplate, b: WhatsAppMessageTemplate): number {
    return a.name.localeCompare(b.name);
  }

  filterTemplates(template: WhatsAppMessageTemplate, filterBy: string): boolean {
    return template.name.toLowerCase().includes(filterBy.toLowerCase());
  }

  getTemplateKey(template: WhatsAppMessageTemplate): string {
    return template.id;
  }

  async mounted() {
    await this.loadMessageTemplates();
  }

  async loadMessageTemplates() {
    try {
      this.messageTemplates = await WhatsAppApi.getTemplates(this.$route.params.id);
      console.log('Templates:', this.messageTemplates);
    } catch (error) {
      console.error('Error loading templates:', error);
      this.$notify.error({
        title: 'Error',
        description: 'Failed to load WhatsApp Message Templates',
      });
    }
  }
}
